(ns manage.content-variant-page.version-switcher.db
  (:require [manage.content-configuration-page.content-configuration.db :as content-configuration.db]
            [re-frame.core :as rf]))

(rf/reg-event-fx :page.content-variant.targeting/publish-version
  (fn [_ [_ version]]
    {:fx [[:async-flow {:id :page.content-variant.targeting/publish-cfn-flow
                        :first-dispatch [:resource.content-function/publish-stage version]
                        :rules [{:when :seen?
                                 :events :resource.content-function/publish-stage-failure
                                 :halt? true
                                 :dispatch [:response-handler/handle-response
                                            {:entity-name "Content variant"
                                             :type :error
                                             :message "Could not publish content variant configuration"}]}
                                {:when :seen?
                                 :events :resource.content-function/publish-stage-success
                                 :halt? true
                                 :dispatch-n [[:response-handler/handle-response
                                               {:entity-name "Content variant"
                                                :type :success
                                                :message "Content variant configuration has been published"}]
                                              ;; Reloads the overview, to get the new "published" version.
                                              [:resource.content-function/get-content-function-overview]]}]}]]}))

(rf/reg-event-fx :page.content-variant.targeting/discard-version
  (fn [_ [_ version]]
    {:fx [[:dispatch [:resource.content-function/delete-stage version]]]}))

(rf/reg-event-fx :page.content-variant.targeting/edit-as-draft
  [(rf/inject-cofx :sub {:draft-version-exists [:resource.content-function-version/contains-version? "draft"]})]
  (fn [{:keys [draft-version-exists]} _]
    {:fx [(if draft-version-exists
            ;; If there is already a draft version, just switch to it.
            [:dispatch [:resource.content-function-version/activate-version "draft"]]

            ;; Otherwise we create it first, and then we switch to it down the line.
            [:dispatch [::content-configuration.db/create-draft]])]}))
